import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Pill, EmptyState } from "./AdminUI";

export default function CategoryReviewTab() {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("pending");

  const load = () => api.get("/categories/admin/suggestions", { params: status ? { status } : {} }).then(r => setData(r.data));
  useEffect(() => { load(); }, [status]); // eslint-disable-line

  const review = async (id, newStatus) => {
    const note = newStatus === "rejected" ? (window.prompt("Optional note for rejection:") || "") : "";
    try { await api.patch(`/categories/admin/suggestions/${id}`, { status: newStatus, admin_note: note }); toast.success("Updated"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  if (!data) return <p className="text-sm text-[#222]/45">Loading…</p>;
  const { suggestions, counts } = data;

  return (
    <div data-testid="admin-category-review-tab">
      <div className="flex gap-2 mb-4 flex-wrap">
        {["pending", "approved", "rejected", ""].map(s => (
          <button key={s || "all"} onClick={() => setStatus(s)} className={`text-xs px-3 py-2 rounded-full font-semibold ${status === s ? "bg-[#222] text-white" : "bg-black/5"}`} data-testid={`category-review-filter-${s || "all"}`}>
            {s ? `${s} (${counts[s] || 0})` : "All"}
          </button>
        ))}
      </div>

      {suggestions.length === 0 ? (
        <EmptyState title="No category suggestions" body="Pros who don't see their trade in the category list can suggest one from their profile editor." testid="admin-category-review-empty" />
      ) : (
        <div className="bg-white rounded-2xl shadow-sm border border-black/5 overflow-hidden">
          <table className="w-full text-sm" data-testid="admin-category-review-table">
            <thead className="bg-black/[0.03] text-[11px] uppercase tracking-wider text-[#222]/50">
              <tr><th className="text-left px-4 py-3">Suggested</th><th className="text-left px-4 py-3">By</th><th className="text-left px-4 py-3">Reason</th><th className="text-left px-4 py-3">Status</th><th className="text-right px-4 py-3">Actions</th></tr>
            </thead>
            <tbody>
              {suggestions.map(s => (
                <tr key={s.id} className="border-t border-black/5" data-testid={`category-suggestion-${s.id}`}>
                  <td className="px-4 py-3 font-semibold">{s.suggested_category}</td>
                  <td className="px-4 py-3 text-[#222]/60">{s.name} ({s.role})</td>
                  <td className="px-4 py-3 text-[#222]/60">{s.reason || "—"}</td>
                  <td className="px-4 py-3"><Pill tone={s.status === "approved" ? "green" : s.status === "rejected" ? "red" : "amber"}>{s.status}</Pill></td>
                  <td className="px-4 py-3 text-right">
                    {s.status === "pending" && (
                      <div className="flex gap-1.5 justify-end">
                        <button onClick={() => review(s.id, "approved")} className="text-xs px-3 py-1.5 rounded-full bg-[#2E6B57]/20 text-[#245544] font-semibold" data-testid={`category-approve-${s.id}`}>Approve</button>
                        <button onClick={() => review(s.id, "rejected")} className="text-xs px-3 py-1.5 rounded-full bg-red-100 text-red-700 font-semibold" data-testid={`category-reject-${s.id}`}>Reject</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
